import { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { useAuthSession } from '../context/AuthSessionContext'

/**
 * React Router 布局守卫：未登录跳转登录页，并带上来源路径便于登录后回跳。
 */
export function RequireAuth() {
  const location = useLocation()
  const { isLoggedIn, hydrateFromStorage } = useAuthSession()

  useEffect(() => {
    hydrateFromStorage()
  }, [hydrateFromStorage])

  if (!isLoggedIn) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  return <Outlet />
}
